import {FC, ReactNode} from 'react'
import {Link} from 'react-router-dom'
import styles from './StartProcedureCard.scss'

interface CardProps {
  to?: string
  onClick?: () => void
  variant: keyof typeof labels
  children: ReactNode
}

const labels = {
  start: '手続き開始',
  next: '次へ',
}

export const StartProcedureCard: FC<CardProps> = ({to, onClick, variant, children}) => {
  const inner = (
    <>
      <div className={styles.title}>{children}</div>
      <div className={styles.button}>{labels[variant]}</div>
    </>
  )

  return to ? (
    <Link className={styles.base} to={to}>
      {inner}
    </Link>
  ) : (
    <div className={styles.base} onClick={onClick}>
      {inner}
    </div>
  )
}
